export class GetFixedCostFilterModel {
  fixedCostId?: number;
  startDate: string = '';
  endDate: string = '';
  pageNumber: number = 1;
  pageSize: number = 12;
}
